export default {
  dashboard: '/dashboard',
  alerts: '/alerts',
  residents: '/residents',
  authority: '/authority-levels',
  healthcareProviders: '/healthcare-providers',
  healthcareProviderGroups: '/healthcare-provider-groups',
  configuration: '/configuration',
  hcpGroups: '/hcp-groups',
};
